import React from 'react';
import { StyleSheet, View } from 'react-native';
import { type useInitCustomizationMachine } from '@sg/shared-fe/features/customization';

import {
  CustomizationNoDressingModal,
  CustomizationOutOfStockModal,
  CustomizationTooFewBasesModal,
} from './modals';

// ────────────────────────────────────────────────────────────────────────────────

export const CustomizationModals = (props: Props) => {
  const {
    actor,
    isOutOfStockModalOpen,
    closeOutOfStockModal,
    setScrollTargetId,
  } = props;

  return (
    <View style={styles.wrapper}>
      <CustomizationNoDressingModal actor={actor} />
      <CustomizationTooFewBasesModal actor={actor} />

      <CustomizationOutOfStockModal
        actor={actor}
        isVisible={isOutOfStockModalOpen}
        onRequestClose={closeOutOfStockModal}
        setScrollTargetId={setScrollTargetId}
      />
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  wrapper: {
    flex: 0,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  actor: ReturnType<typeof useInitCustomizationMachine>;
  isOutOfStockModalOpen: boolean;
  closeOutOfStockModal: () => void;
  setScrollTargetId?: (id: string) => void;
};
